import React from "react"

const Footer = props => (
   <footer>
      <div className="container-fluid">
         <p className="text-center">
            © {new Date().getFullYear()} ESM SYSTEM
         </p>
      </div>
   </footer>
);

export default Footer;
